import { render, staticRenderFns } from "./AdminTeamModal.vue?vue&type=template&id=236961c8&scoped=true"
import script from "./AdminTeamModal.vue?vue&type=script&lang=js"
export * from "./AdminTeamModal.vue?vue&type=script&lang=js"
import style0 from "./AdminTeamModal.vue?vue&type=style&index=0&id=236961c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236961c8",
  null
  
)

export default component.exports